export default "__VITE_ASSET__Du46AELn__"